import { useQuery } from "@tanstack/react-query";
import { api, generateQueryKey } from "@/lib/api";

export interface WebsiteChannel {
  channel: string;
  page_view_count: number | "All"; // "All" for the all channels option
}

export interface WebsiteChannelsResponse {
  channels: WebsiteChannel[];
}

export function useWebsiteChannels(url?: string) {
  return useQuery({
    queryKey: [
      ...generateQueryKey("datahub/webpages/channels/"),
      url || "__no_url__",
    ],
    queryFn: async () => {
      return api.get<WebsiteChannelsResponse>("datahub/webpages/channels/", {
        params: url ? { url } : undefined,
      });
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: Boolean(url),
  });
}
